export default "/static/dashboard/build/app/img/v2/757ca0d21ebe1caed5b016acd7ad3416.png";